import { AddShoppingCart, AllInbox, BusinessCenter, Group, MenuBook, Person } from "@mui/icons-material";
import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UserTypeId, useAccountStore } from "../common/account";
import { PageTitle } from "../layout/PageTitle";

export default function DashboardPage() {
    const navigate = useNavigate();
    const { userTypeId } = useAccountStore(p => ({ userTypeId: p.data?.accessTokenDecoded.userTypeId }));

    function card(title: string, icon: () => JSX.Element, description: string, path: string, linkTitle: string) {
        return <Grid item xs={12} md={6} lg={4} xl={3}>
            <Card onClick={() => navigate(path)} style={{ cursor: "pointer" }}>
                <CardContent>
                    <Box mb={2}>
                        <Grid container direction="row" alignItems="center" spacing={1}>
                            <Grid item>
                                {icon()}
                            </Grid>
                            <Grid item>
                                <Typography variant="h5" color="textPrimary" component="h2">
                                    {title}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {description}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Box>
                        <Button>{linkTitle}</Button>
                    </Box>
                </CardActions>
            </Card>
        </Grid>
    }

    const isAdmin = userTypeId === UserTypeId.Admin;
    const isTmSupervisor = userTypeId === UserTypeId.TmSupervisor || userTypeId === UserTypeId.Supervisor || userTypeId === UserTypeId.TmManager;
    const isTmAgent = userTypeId === UserTypeId.TmAgent || userTypeId === UserTypeId.User;
    const isTm = isTmSupervisor || isTmAgent;

    return <>
        <PageTitle title="Dashboard" />
        <Grid container spacing={4}>
            {(isAdmin || isTmSupervisor) && card("Users", () => <Person />, "", "/users", "Users page")}
            {isAdmin && card("Products", () => <AllInbox />, "", "/products", "Products page")}
            {isAdmin && card("Customers", () => <Group />, "", "/customers", "Customers page")}
            {isAdmin && card("Articles", () => <MenuBook />, "", "/articles", "Articles page")}
            {isAdmin && card("Inventory transactions", () => <BusinessCenter />, "", "/inventory-transactions", "Inventory transactions page")}
            {isAdmin && card("System tasks", () => <BusinessCenter />, "", "/system-tasks", "System tasks page")}
            {(isAdmin || isTm) && card("TM Orders", () => <AddShoppingCart />, "", "/tm/orders", "TM orders page")}
            {(isAdmin || isTm) && card("New TM Order", () => <AddShoppingCart />, "", "/tm/orders/new", "Create")}
            {(isAdmin || isTmSupervisor) && card("TM Operators report", () => <AddShoppingCart />, "", "/reports/tm-operators", "TM Operators report page")}
        </Grid>
    </>;
}
